"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = waitForStylesheet;
function waitForStylesheet(element) {
  var timeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var isLoaded = function isLoaded(_ref) {
    var href = _ref.href;

    return Array.from(document.styleSheets).map(function (_ref2) {
      var href = _ref2.href;
      return href;
    }).includes(href);
  };

  var whenLoaded = function whenLoaded(cb) {
    if (isLoaded(element)) {
      cb();
    } else {
      setTimeout(function () {
        return whenLoaded(cb);
      }, 10);
    }
  };

  return new Promise(function (resolve) {
    whenLoaded(resolve);
    if (timeoutMs > 0) {
      setTimeout(resolve, timeoutMs);
    }
  });
};